// import { ThemeProvider } from '@emotion/react';
// import { createTheme } from '@mui/material';
// import { BrowserRouter } from 'react-router-dom';
// import { ToastContainer } from 'react-toastify';
// import './App.css';
// import Router from './Pages/Index';
// import './style/product.css';
// import { LoaderProvider } from './Utils/LoaderContext';
// import Loader from './Utils/Loader';

// function App() {

//   const theme = createTheme({
//     palette: {
//       primary: {
//         main: '#011638',
//       },
//       secondary: {
//         main: '#b9d6f2'
//       }
//     }
//   });

//   return (
//     <>
//       <ToastContainer />
//       <ThemeProvider theme={theme}>
//         <LoaderProvider>
//           <Loader />
//           <BrowserRouter>
//             <Router />
//           </BrowserRouter>
//         </LoaderProvider>
//       </ThemeProvider>
//     </>
//   )
// }

// export default App;


import { ThemeProvider, CssBaseline, createTheme } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import './App.css';
import './style/product.css';
import 'react-toastify/dist/ReactToastify.css'; // Make sure toast styles are applied
import Router from './Pages/Index';
import { LoaderProvider } from './Utils/LoaderContext';
import Loader from './Utils/Loader';

function App() {
  const theme = createTheme({
    palette: {
      primary: {
        main: '#011638',
      },
      secondary: {
        main: '#b9d6f2',
      },
    },
    typography: {
      fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline /> {/* Normalize & responsive baseline */}
      <ToastContainer position="top-right" autoClose={3000} />
      <LoaderProvider>
        <Loader />
        <BrowserRouter>
          <Router />
        </BrowserRouter>
      </LoaderProvider>
    </ThemeProvider>
  );
}

export default App;
